export default __webpack_public_path__ + "static/media/carrot.84372080.svg";